import { status } from 'skin/event/status';

const next = (obj, ms, story, data, d, action) => {
	// const name = data.curData.values.fld.name;
	console.log('[Отчет - Мастер] событие', obj);
	const f = data.getAll(ms);
	console.log('f', f)
	const o = {
		name: 'Движение товара',
		in: {
			...f.date,
			...f.txt,
		},
		pug: true,
	};
	const act = {
		type: 'data',
		action: 'wAdd',
		code: 'msProdMove',
		data: o,
	};
	action(act);
	return status.action;
};

export default next;
